import { createSelector } from '@reduxjs/toolkit';
import { TPageResponse, TStoreState } from 'redux/types';
import {
	TEudrStore,
	TEudrRegParseResponsePayload,
	TEudrPlansResponsePayload,
	TEudrServiceStatusesResponsePayload,
	TEudrItem,
} from './types';

const getEudrState = (state: TStoreState): TEudrStore => state.eudr;
export const getEudr = createSelector([getEudrState], (eudr: TEudrStore) => eudr);

export const getEudrRegParser = createSelector(
	[getEudr],
	(eudr: TEudrStore): TEudrRegParseResponsePayload => eudr.regParser,
);

export const getEudrRegParserLoading = createSelector(
	[getEudr],
	(eudr: TEudrStore): boolean => eudr.regParserLoading,
);

export const getEudrRegParserError = createSelector(
	[getEudr],
	(eudr: TEudrStore): string => eudr.regParserError,
);

export const getEudrRegisterLoading = createSelector(
	[getEudr],
	(eudr: TEudrStore): boolean => eudr.registerLoading,
);

export const getEudrRegisterError = createSelector(
	[getEudr],
	(eudr: TEudrStore): string => eudr.registerError,
);

export const getEudrPlans = createSelector(
	[getEudr],
	(eudr: TEudrStore): TEudrPlansResponsePayload => eudr.plans,
);

export const getEudrServiceStatuses = createSelector(
	[getEudr],
	(eudr: TEudrStore): TEudrServiceStatusesResponsePayload => eudr.serviceStatuses,
);

export const getEudrItemsLoading = createSelector(
	[getEudr],
	(eudr: TEudrStore): boolean => eudr.eudrItemsLoading,
);

export const getEudrItems = createSelector(
	[getEudr],
	(eudr: TEudrStore): TPageResponse<TEudrItem> | null => eudr.eudrItems,
);

export const getEudrActivateLoading = createSelector(
	[getEudr],
	(eudr: TEudrStore): boolean => eudr.activateEudrLoading,
);

export const getGenerateInvoiceEudrLoading = createSelector(
	[getEudr],
	(eudr: TEudrStore): boolean => eudr.generateInvoiceEudrLoading,
);

export const getDownloadEudrLastInvoiceLoading = createSelector(
	[getEudr],
	(eudr: TEudrStore): boolean => eudr.downloadEudrLastInvoiceLoading,
);
